import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';
import { getHomeSchema } from '@/types/home';

const BASE = `${INTERNAL_V1}/home`;

const getHome = async (params?: object, token?: string) => {
  const response = await damRequest('GET', `${BASE}`, token);
  return getHomeSchema.parse(response);
};

export { getHome };
